'use strict'

/**
 * Name: ブラウザの情報を<html>に追加する
 * Page:
 * ===========================================
 */

import UAParser from 'ua-parser-js'

const uaParser = new UAParser()
const ua = uaParser.getResult()

/**
 * スペースをハイフン位変換する
 * @param {String} str
 */
function replaceSpace(str) {
  if (str) {
    return manualLowercase(str.replace(/\s+/g, '-'))
  } else {
    return 'undefined'
  }
}

/**
 * 大文字を小文字に変換する
 * @param {String} str
 */
function manualLowercase(str) {
  return str.replace(/[A-Z]/g, (ch) => {
    return String.fromCharCode(ch.charCodeAt(0) | 32)
  })
}

/**
 * 62.2545.54などのバージョン情報を切り取る
 * @param {String} str
 */
function versionFloor(str) {
  const indexOf = (str.indexOf('.')) ? str.indexOf('.') : false
  if (indexOf) {
    return str.slice(0, indexOf)
  } else {
    return str
  }
}

export const AddHtmlTagClass = () => {
  if (ua.browser) {
    document.documentElement.classList.add(
      `is-browser-${replaceSpace(ua.browser.name)}`,
      `is-browser-ver-${replaceSpace(versionFloor(ua.browser.version))}`,
      `is-os-${replaceSpace(ua.os.name)}`,
      `is-os-ver-${replaceSpace(versionFloor(ua.os.version))}`,
      `is-device-${replaceSpace(ua.device.type)}`,
      `is-device-model-${replaceSpace(ua.device.model)}`
    )
  }
}

export default ua
